export const DEFAULT_IMAGE_ICON_SIZE = 33;

export const THUMBNAIL_WIDTH = 60;

export const NUMBER_OF_OPTIONS_TO_SHOW_BEFORE_COLLAPSE = 1;

export const MAX_DESCRIPTION_LINE_LENGTH = 500;
export const MAX_MODIFIER_LENGTH = 485;

export const SPECS = {
  DontRedirectToSiteOnFailedFetch: 'specs.stores.DontRedirectToSiteOnFailedFetch',
  CheckoutExcludeGoogleAutoComplete: 'specs.stores.CheckoutExcludeGoogleAutoComplete',
  ShouldFetchCustomSettingsAndCustomizeCheckoutLayout:
    'specs.stores.ShouldFetchCustomSettingsAndCustomizeCheckoutLayout',
  ShouldSplitBillingInfoPrefill: 'specs.stores.ShouldSplitBillingInfoPrefill',
  SlotSpacingAndDividers: 'specs.stores.SlotSpacingAndDividers',
  HideBillingFormForPayPalAndManualNotBrazil: 'specs.stores.HideBillingFormForPayPalAndManualNotBrazil',
  EnablePlaceOrderButtonForExistingNoAddressCustomer: 'specs.stores.EnablePlaceOrderButtonForExistingNoAddressCustomer',
  WithCheckoutHackForReact18Tests: 'specs.stores.WithCheckoutHackForReact18Tests',
  GiftCartSeviceDownCheckout: 'specs.stores.GiftCartSeviceDownCheckout',
  MoveSlotAboveCheckoutButton: 'specs.stores.MoveSlotAboveCheckoutButton',
  ShowVatIdOnBillingForIsrael: 'specs.stores.ShowVatIdOnBillingForIsrael',
  AddLayoutConfigToLineItemsAutoGql: 'specs.stores.AddLayoutConfigToLineItemsAutoGql',
  ShouldHandlePaylinksRedirectError: 'specs.stores.ShouldHandlePaylinksRedirectError',
  UseNewSubscriptionCheckboxInCustomerDetailsForm: 'specs.stores.UseNewSubscriptionCheckboxInCustomerDetailsForm',
  RefactorFormServiceToCalcExtendedFields: 'specs.stores.RefactorFormServiceToCalcExtendedFields',
  MigrateSubscriptionToCheckoutForm: 'specs.stores.MigrateSubscriptionToCheckoutForm',
  AddSlotToCheckoutPolicies: 'specs.stores.AddSlotToCheckoutPolicies',
  TestNewSubscriptionCheckboxLocation: 'specs.stores.TestNewSubscriptionCheckboxLocation',
  UseNewSubscriptionView: 'specs.stores.UseNewSubscriptionView',
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems',
  SupportFreeTrialLineItems: 'specs.stores.SupportFreeTrialLineItems',
  SupportDeliveryProfilesPhase2: 'specs.stores.SupportDeliveryProfilesPhase2',
  ShouldFixZoomForCheckoutInClassic: 'specs.stores.ShouldFixZoomForCheckoutInClassic',
  GiftCardAddToCartSettings: 'specs.stores.ShowGiftCardAddToCartSettings',
  UsePaymentRequired: 'specs.stores.UsePaymentRequired',
  RefactorPlaceOrderStateCalculation: 'specs.stores.RefactorPlaceOrderStateCalculation',
  UseDeliverySectionFromLib: 'specs.stores.UseDeliverySectionFromLib',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  AccessibilityOptimizedPageHierarchy: 'specs.stores.AccessibilityOptimizedPageHierarchy',
  AllowMemberLoginStepWithoutMA: 'specs.ecom.AllowMemberLoginStepWithoutMA',
  CheckoutHeaderAndLogoA11yChanges: 'specs.stores.CheckoutHeaderAndLogoA11yChanges',
  UseAdditionalInfoFormLabel: 'specs.ecom.UseAdditionalInfoFormLabel',
  CollectPaymentForZeroPriceWhenPaymentRequired: 'specs.ecom.CollectPaymentForZeroPriceWhenPaymentRequired',
  UseCheckoutCompletedFlagForNavigation: 'specs.ecom.UseCheckoutCompletedFlagForNavigation',
  NewItemOptions: 'specs.ecom.NewItemOptions',
  SupportModifiersOnCheckout: 'specs.ecom.SupportModifiersOnCheckout',
  MakeGetPaymentDetailsIdSync: 'specs.ecom.MakeGetPaymentDetailsIdSync',
  AddPaymentCurrencyToCheckoutQuery: 'specs.ecom.AddPaymentCurrencyToCheckoutQuery',
  SupportPaymentCurrency: 'specs.ecom.SupportPaymentCurrency',
  FixPaymentRequestViewCss: 'specs.ecom.FixPaymentRequestViewCss',
  SupportExplicitURLParams: 'specs.ecom.SupportExplicitURLParams',
  AlwaysSendCurrencyHeader: 'specs.ecom.AlwaysSendCurrencyHeader',
  ErrorHandlerOnCheckout: 'specs.ecom.ErrorHandlerOnCheckout',
};

export const A11yIds = {
  SummarySection: 'summary-section',
};
